module.exports = __webpack_public_path__ + "static/img/left.8806241.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pictures/left.png
// module id = FB04
// module chunks = 1